import React, {useEffect, useRef} from 'react';

function Check({mixed, ...props}) {
    const ref=useRef(null);
    useEffect(()=>{if(ref.current)ref.current.indeterminate=!!mixed;},[mixed]);
    return <input type="checkbox" ref={ref} {...props} className="accent-gold h-5 w-5 shrink-0"/>;
}
export function periodCategories(groups, categories) {
    const rows=categories.map(c=>({...c,groups:groups.filter(g=>g.category_id===c.id)}));
    const other=groups.filter(g=>!categories.some(c=>c.id===g.category_id));
    if(other.length)rows.push({id:'other',name:'Other services',groups:other});
    return rows.filter(c=>c.groups.length);
}
export function PeriodServiceSummary({ids,groups,categories}) {
    return <div className="flex flex-wrap gap-2 mt-2">{periodCategories(groups,categories).map(c=>{
        const selected=c.groups.filter(g=>g.service_ids.some(id=>ids.includes(id)));
        if(!selected.length)return null;
        const all=c.groups.every(g=>g.service_ids.every(id=>ids.includes(id)));
        return <span key={c.id} className="rounded-lg border border-gold/30 bg-gold/10 px-2 py-1 text-xs text-gold break-words" style={{overflowWrap:'anywhere'}}>
            {c.name}{all?'':`: ${selected.map(g=>g.name).join(', ')}`}
        </span>;
    })}</div>;
}
export function PeriodServices({ids,groups,categories,onChange,disabled}) {
    const toggle=members=>{
        const all=members.every(id=>ids.includes(id));
        onChange(all?ids.filter(id=>!members.includes(id)):[...new Set([...ids,...members])]);
    };
    return <fieldset disabled={disabled} className="min-w-0 space-y-3">
        <legend className="text-sm text-white font-semibold mb-2">Services for this period</legend>
        <p className="text-xs text-white/60">Tick a whole category, or expand it to choose services.</p>
        {periodCategories(groups,categories).map(c=>{
            const members=c.groups.flatMap(g=>g.service_ids),count=members.filter(id=>ids.includes(id)).length;
            return <div key={c.id} className="rounded-xl border border-white/15 p-3">
                <div className="flex gap-3 items-start"><Check aria-label={`All ${c.name}`} checked={count===members.length} mixed={count>0 && count<members.length} onChange={()=>toggle(members)}/>
                    <details className="min-w-0 flex-1"><summary className="text-white cursor-pointer break-words" style={{overflowWrap:'anywhere'}}>{c.name} <span className="text-xs text-gold">— choose services</span></summary>
                        <div className="space-y-3 mt-3">{c.groups.map(g=><label key={g.id} className="flex items-start gap-3 text-sm text-white/80">
                            <Check aria-label={g.name} checked={g.service_ids.every(id=>ids.includes(id))} mixed={g.service_ids.some(id=>ids.includes(id)) && !g.service_ids.every(id=>ids.includes(id))} onChange={()=>toggle(g.service_ids)}/>
                            <span className="min-w-0" style={{overflowWrap:'anywhere'}}>{g.name}</span>
                        </label>)}</div>
                    </details>
                </div>
            </div>;
        })}
        {!ids.length && <p className="text-sm text-gold">Choose at least one category or service for this period.</p>}
        <PeriodServiceSummary ids={ids} groups={groups} categories={categories}/>
    </fieldset>;
}
